__turbopack_context__.v({
  "animate-wobble-hor-bottom": "sqDWRW_animate-wobble-hor-bottom",
  "fade-in": "sqDWRW_fade-in",
  "fade-in-bottom": "sqDWRW_fade-in-bottom",
  "fade-in-top": "sqDWRW_fade-in-top",
  "fade-out": "sqDWRW_fade-out",
  "fade-out-bottom": "sqDWRW_fade-out-bottom",
  "fade-out-top": "sqDWRW_fade-out-top",
  "flip-in-ver-left": "sqDWRW_flip-in-ver-left",
  "scale-in-center": "sqDWRW_scale-in-center",
  "scale-in-tl": "sqDWRW_scale-in-tl",
  "scale-in-top": "sqDWRW_scale-in-top",
  "scale-in-ver-center": "sqDWRW_scale-in-ver-center",
  "scale-out-top": "sqDWRW_scale-out-top",
  "scale-up-center": "sqDWRW_scale-up-center",
  "shake-horizontal": "sqDWRW_shake-horizontal",
  "slide-in-bottom": "sqDWRW_slide-in-bottom",
  "slide-in-fwd-center": "sqDWRW_slide-in-fwd-center",
  "slide-in-left": "sqDWRW_slide-in-left",
  "slide-in-right": "sqDWRW_slide-in-right",
  "slide-in-top": "sqDWRW_slide-in-top",
  "slide-out-bottom": "sqDWRW_slide-out-bottom",
  "slide-out-left": "sqDWRW_slide-out-left",
  "slide-out-right": "sqDWRW_slide-out-right",
  "slide-out-top": "sqDWRW_slide-out-top",
  "swing-in-top-fwd": "sqDWRW_swing-in-top-fwd",
  "tilt-in-fwd-tr": "sqDWRW_tilt-in-fwd-tr",
  "validation-message": "sqDWRW_validation-message",
  "wobble-hor-bottom": "sqDWRW_wobble-hor-bottom",
});
